import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

// Components
import H3 from '@/components/base/Headings/H3';
import ApiAccessHeader from '@/components/pages/settings/integrations/ApiAccessHeader';
import ApiAccessTable from '@/components/pages/settings/integrations/ApiAccessTable';
import { BackButton } from '@/components/pages/settings/integrations/BackButton';
import { Overview } from '@/components/pages/settings/integrations/Overview';
import { ZapierIntegration } from '@/components/pages/settings/integrations/ZapierIntegration';

function PageContent() {
    const { t } = useTranslation('integrations');
    const router = useRouter();
    const { sub_page } = router.query as { sub_page: 'zapier' };
    const { clearUrlQueriesWithoutReload } = useRouterQuery();

    const [displayedContent, setDisplayedContent] = useState<'overview' | 'zapier' | 'api_key'>(
        'overview'
    );

    useEffect(() => {
        if (sub_page) {
            setDisplayedContent('zapier');
            clearUrlQueriesWithoutReload();
        }
    }, [sub_page]);

    function handleBackClick() {
        setDisplayedContent('overview');
    }

    if (displayedContent === 'overview') {
        return <Overview onClick={setDisplayedContent} />;
    }

    if (displayedContent === 'zapier') {
        return (
            <div
                className="flex h-full w-full flex-col gap-12 @container"
                data-testid="zapier-integration">
                <BackButton onClick={handleBackClick} />
                <ZapierIntegration />
            </div>
        );
    }

    return (
        <div className="flex w-full flex-col gap-12">
            <BackButton onClick={handleBackClick} />
            <ApiAccessHeader />
            <div className="flex flex-1 flex-col space-y-8">
                <H3>{t('api_access.table_keys.title')}</H3>
                <ApiAccessTable />
            </div>
        </div>
    );
}

export default PageContent;
